import { ReactNode } from 'react';

import { TwoColumnRiver, TwoColumnRiverProps } from '@zapier/design-system';

import { RichTextHtml } from '../../RichTextHtml/RichTextHtml';
import { RichTextHTMLString } from '../types';
import { CTAType, SectionName, useAvroTracking } from '../../../observability';

type Props = Omit<TwoColumnRiverProps, 'description' | 'ctaText'> & {
  children: ReactNode;
  ctaText: string;
  description: RichTextHTMLString;
};

export function TwoColumnRiverSection({
  children,
  description,
  ...rest
}: Props) {
  const { emitCTAClickEvent } = useAvroTracking();
  const { ctaHref, ctaText } = rest;
  const handleCTAClick = () => {
    if (ctaText && ctaHref)
      emitCTAClickEvent({
        text: ctaText,
        section: SectionName.TwoColumnRiverSection,
        href: ctaHref,
      });
  };

  const handleSecondaryCTAClick = () => {
    if (ctaText && ctaHref)
      emitCTAClickEvent({
        text: ctaText,
        section: SectionName.TwoColumnRiverSection,
        href: ctaHref,
        type: CTAType.cta_link,
      });
  };

  return (
    <TwoColumnRiver
      description={
        <RichTextHtml
          backgroundColor={rest.backgroundColor}
          html={description}
        />
      }
      media={children}
      onCtaClick={handleCTAClick}
      onSecondaryCtaClick={handleSecondaryCTAClick}
      {...rest}
    />
  );
}
